<template>
  <v-layout row wrap>
    <v-flex xs12>
      <ul class="navigation subnav" :class="{'alert-menu__active': alert}">
        <li>
          <eshop-link :to="{ path: '/jednorazove-nakupy' }">Jednorázové nákupy</eshop-link>
        </li>
        <li>
          <eshop-link :to="{ path: '/postupne-nakupy' }">Postupné nákupy</eshop-link>
        </li>
        <li>
          <eshop-link :to="{ path: '/moje-zbozi' }">Moje zboží</eshop-link>
        </li>
        <li>
          <eshop-link :to="{ path: '/moje-faktury' }">Moje faktury</eshop-link>
        </li>
      </ul>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    data () {
      return {
        alert: true
      }
    }
  }
</script>
